<template>
  <div class="pb-3" >
    <va-card :title="$t(`plan-items.cards.${titleCard}`)">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <div class="row">
            <div class="flex md12">
              <ValidationProvider rules="required" name="Descrição" v-slot="{ errors }">
                <va-input
                  v-model="item.description"
                  :label="$t('plan-items.forms.descriptionLabel')"
                  :placeholder="$t('plan-items.forms.descriptionPlaceholder')"
                  :success="errors.length == 0 && item.description.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <div class="d-flex mt-3">
                <va-button
                  type="submit"
                  :disabled="buttonSubmitDisabled"
                  color="success"
                  class="my-0">
                  {{ textSubmit }}
                </va-button>
                <va-button
                  type="button"
                  class="my-0"
                  color="danger"
                  @click="cancel">
                  {{ $t("forms.cancel") }}
                </va-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'
export default {
  name: 'PlanItemsAddUpdate',
  props: {
    page: {
      type: Number,
      required: true,
    },
    titleCard: {
      type: String,
      required: true,
    },
    updateId: {
      required: true,
    },
  },
  data () {
    return {
      item: {
        description: '',
      },
      buttonSubmitDisabled: false,
      textSubmit: this.$t('forms.submit'),
    }
  },
  mounted () {
    this.item.description = ''
    if (this.updateId !== null) {
      this.item_get(this.updateId)
    }
  },
  watch: {
    updateId (value) {
      if (this.updateId !== null) {
        this.item_get(this.updateId)
      } else {
        this.item.description = ''
      }
    },
  },
  methods: {
    cancel () {
      this.$emit('showAdd', false)
    },
    item_get (id) {
      this.$apollo.addSmartQuery('item', {
        query: gql`
        query MyQuery($id: Int!) {
          item: plan_item_by_pk(id: $id) {
            description
          }
        }
        `,
        variables: {
          id,
        },
        manual: true,
        result ({ data, loading }) {
          if (!loading) {
            this.item = Object.assign({}, data.item)
          }
        },
      })
    },
    onSubmit () {
      this.buttonSubmitDisabled = true
      this.textSubmit = this.$t('forms.submitting')
      const { description } = this.item
      this.$apollo
        .mutate({
          mutation: (
            this.updateId !== null ? gql`
                mutation MyMutation($id: Int!, $description: String!) {
                  update_plan_item_by_pk(pk_columns: {id: $id}, _set: {description: $description}) {
                    id
                  }
                }
                ` : gql`
                  mutation MyMutation( $description: String!) {
                  insert_plan_item(objects: {description: $description}) {
                    affected_rows
                  }
                }
                `),
          variables: this.updateId !== null ? {
            description,
            id: this.updateId,
          } : { description },
        })
        .then(data => {
          this.buttonSubmitDisabled = false
          this.textSubmit = this.$t('forms.submit')
          this.item.description = ''
          this.$emit('showAdd', false)
          this.$emit('showMore', this.page)
          this.showToast(
            this.$t(
              this.updateId != null ? 'toasts.successUpdate' : 'toasts.successCreate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          this.buttonSubmitDisabled = false
          this.textSubmit = this.$t('forms.submit')
          this.item.description = ''
          this.$emit('showAdd', false)
          this.showToast(
            this.$t(
              this.updateId != null ? 'toasts.errorUpdate' : 'toasts.errorCreate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
}
</script>

<style>

</style>
